import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center gap-1">
      <button
        className="btn btn-sm btn-light rounded-circle p-2 d-flex align-items-center justify-content-center border"
        style={{ width: "34px", height: "34px", color: "#475569" }}
        onClick={() => navigate(-1)}
        title="Go Back"
        aria-label="Back"
      >
        <FaChevronLeft size={12} />
      </button>
      <button
        className="btn btn-sm btn-light rounded-circle p-2 d-flex align-items-center justify-content-center border"
        style={{ width: "34px", height: "34px", color: "#475569" }}
        onClick={() => navigate(1)}
        title="Go Forward"
        aria-label="Forward"
      >
        <FaChevronRight size={12} />
      </button>
    </div>
  );
};

export default BackButton;
